import { useContext } from "react";

import type { ConfigContextValue } from "./context.ts";
import { ConfigContext } from "./context.ts";

export function useConfig(): ConfigContextValue {
  const context = useContext(ConfigContext);

  if (!context) {
    throw new Error("useConfig must be used within ConfigProvider");
  }

  return context;
}
